import { BaseEntity } from "yt-ng-framework";

export class Magacin extends BaseEntity {
    constructor(){
        super();
    }

    Naziv: string = null;
    SNaziv: string = null;
    SortIndex: any = null;

    Deserialize(input: any){
        this.ID = input.ID;
        this.Naziv = input.Naziv;
        this.SNaziv = input.SNaziv;
        this.SortIndex = input.SortIndex;       
        return this;
    }

    Serialize(input: Magacin){
        return input;
    }

}